import React, { useState, forwardRef } from 'react';
import PropTypes from 'prop-types';

import { RE } from '~/modules/helpers/regexp';

// 𝘣𝘴 𝘣𝘳𝘦𝘢𝘬𝘱𝘰𝘪𝘯𝘵𝘴: 𝗦𝗺𝗮𝗹𝗹, 𝗠𝗲𝗱𝗶𝘂𝗺, 𝗟𝗮𝗿𝗴𝗲, 𝗘𝘅𝘁𝗿𝗮 𝗹𝗮𝗿𝗴𝗲
export const iconSizes = ['sm', 'md', 'lg', 'xl'];

const Icon = forwardRef((props, ref) => {
    const {
        size,
        type,
        typeOnHover,
        className,
        onMouseOver,
        onMouseOut,
        ['data-testid']: testId,
        ...rest
    } = props;

    const [isHovering, setIsHovering] = useState(false);

    if (type) {
        const iconType = `icon-${type}`;

        let classes = [
            'icon',
            isHovering
                ? typeOnHover
                    ? `icon-${typeOnHover}`
                    : iconType
                : iconType
        ];

        if (size && iconSizes.includes(size)) {
            classes[2] = `icon-${size}`;
        }

        if (className?.length) {
            classes = classes.concat(className.split(RE.OneOrMoreWhitespace));
        }

        classes = classes.join('\u0020');

        return (
            <i
                data-testid={testId || iconType}
                ref={ref}
                {...rest}
                className={classes}
                onMouseOver={(...args) => {
                    setIsHovering(true);
                    onMouseOver?.(...args);
                }}
                onMouseOut={(...args) => {
                    setIsHovering(false);
                    onMouseOut?.(...args);
                }}
            />
        );
    }
});

Icon.propTypes = {
    className: PropTypes.string,
    onMouseOver: PropTypes.func,
    onMouseOut: PropTypes.func,
    // 𝘐𝘤𝘰𝘯 𝘪𝘥𝘦𝘯𝘵𝘪𝘧𝘪𝘦𝘳 𝘤𝘰𝘳𝘳𝘦𝘴𝘱𝘰𝘯𝘥𝘪𝘯𝘨 𝘵𝘰 𝘵𝘩𝘦 𝙞𝙘𝙤𝙣-* 𝘤𝘭𝘢𝘴𝘴 𝘷𝘢𝘭𝘶𝘦.
    type: PropTypes.string.isRequired,
    size: PropTypes.oneOf(iconSizes)
};

export default Icon;
